import React, { useEffect, useMemo } from "react";
import "./ExploreLearningSection.css";
import AOS from "aos";
import "aos/dist/aos.css";
import data from "./exploreLearningData.json";
import { useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { useHistory } from "react-router-dom";
import { isFoundationUnlocked } from "utils/foundationUnlock";

function ExploreLearningSection() {
  const history = useHistory();
  const { instance } = useMsal();

  const activeAccount = instance.getActiveAccount();
  const userLevelDes = activeAccount?.idTokenClaims?.jobFamilyDescription;

  const userData = useSelector((state) => state.userDetails.userData?.[0]);

  const { coursesByHub } = useSelector((state) => state.courseDetails);

  const isEmpty = (value) =>
    value === null || value === undefined || value === "" || value === "NULL";

  const userLevel = isEmpty(userLevelDes) ? userData?.level : userLevelDes;

  // Ensure data is ready before computing unlock status
  const isDataReady =
    Boolean(userData) &&
    Boolean(userLevel) &&
    Boolean(coursesByHub) &&
    Object.keys(coursesByHub).length > 0;

  const isFoundationCompleted = useMemo(() => {
    if (!isDataReady) return null;

    return isFoundationUnlocked({
      coursesByHub,
      userData,
      userLevel,
    });
  }, [isDataReady, coursesByHub, userData, userLevel]);

  const handleHubClick = (hubName) => {
    history.push({
      pathname: "/learningHubs",
      state: { activeHub: hubName },
    });
  };

  useEffect(() => {
    const handleAOS = () => {
      if (window.innerWidth > 768) {
        AOS.init({ duration: 800 });
      } else {
        AOS.refreshHard();
        document
          .querySelectorAll("[data-aos]")
          .forEach((el) => el.removeAttribute("data-aos"));
      }
    };

    handleAOS();
    window.addEventListener("resize", handleAOS);
    return () => window.removeEventListener("resize", handleAOS);
  }, []);

  const lockIcon = process.env.PUBLIC_URL + "/Assets/Home/security-lock.png";

  const LockedOverlay = () => (
    <div className="locked-overlay">
      <img src={lockIcon} alt="lock" className="security-lock-icon" />
    </div>
  );

  const shouldLock = (hubName) => {
    if (hubName === "Foundation") return false;

    if (isFoundationCompleted === null) return false;

    return !isFoundationCompleted;
  };

  return (
    <div className="learn-hubs-container">
      {/* WRAP 1 */}
      <div className="learn-hubs-wrap wrap1">
        {data.wrap1.map((row, index) => (
          <div className="learn-hubs-row" data-aos={row.aos} key={index}>
            <div className="learn-hubs-box">
              {row.type === "double"
                ? row.items.map((item, i) => {
                    const locked = shouldLock(item.hubName);

                    return (
                      <div
                        className={`learn-hubs-sub-box ${
                          locked ? "locked" : ""
                        }`}
                        key={i}
                        onClick={
                          !locked
                            ? () => handleHubClick(item.hubName)
                            : undefined
                        }
                        style={{
                          cursor: locked ? "not-allowed" : "pointer",
                        }}
                      >
                        <img
                          src={process.env.PUBLIC_URL + item.img}
                          alt="learning-hubs"
                          className="learning-hubs-img"
                        />
                        <div className="learn-hub-content-box">
                          <img
                            src={process.env.PUBLIC_URL + item.icon}
                            alt="learning-hubs"
                            className="learning-hubs-icon"
                          />
                          <h3>{item.title}</h3>
                        </div>

                        {locked && <LockedOverlay />}
                      </div>
                    );
                  })
                : (() => {
                    const locked = shouldLock(row.hubName);

                    return (
                      <div
                        className={locked ? "locked" : ""}
                        onClick={
                          !locked
                            ? () => handleHubClick(row.hubName)
                            : undefined
                        }
                        style={{
                          cursor: locked ? "not-allowed" : "pointer",
                        }}
                      >
                        <img
                          src={process.env.PUBLIC_URL + row.img}
                          alt="learning-hubs"
                          className="learning-hubs-img"
                        />
                        <div className="learn-hub-content-box">
                          <img
                            src={process.env.PUBLIC_URL + row.icon}
                            alt="learning-hubs"
                            className="learning-hubs-icon"
                          />
                          <h3>{row.title}</h3>
                        </div>

                        {locked && <LockedOverlay />}
                      </div>
                    );
                  })()}
            </div>
          </div>
        ))}
      </div>

      {/* WRAP 2 */}
      <div className="learn-hubs-wrap wrap2">
        {data.wrap2.map((item, index) => {
          const locked = shouldLock(item.hubName);

          return (
            <div className="learn-hubs-row" data-aos={item.aos} key={index}>
              <div
                className={`learn-hubs-box ${locked ? "locked" : ""}`}
                onClick={
                  !locked ? () => handleHubClick(item.hubName) : undefined
                }
                style={{
                  cursor: locked ? "not-allowed" : "pointer",
                }}
              >
                <img
                  src={process.env.PUBLIC_URL + item.img}
                  alt="learning-hubs"
                  className="learning-hubs-img"
                />
                <div className="learn-hub-content-box">
                  <img
                    src={process.env.PUBLIC_URL + item.icon}
                    alt="learning-hubs"
                    className="learning-hubs-icon"
                  />
                  <h3>{item.title}</h3>
                </div>

                {locked && <LockedOverlay />}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ExploreLearningSection;
